import { gql } from '@apollo/client/core';

export const signpostContentBlockFragment = gql`
  fragment SignpostContentBlockFields on SignpostContentBlock {
    pageTitle
    text
    image {
      url
      title
    }
    buttonText
    isExternal
    url
  }
`;
